import { API, ENDPOINTS } from '@/app/services/api-url';
import BillingHistoryPayInvoice from './billing-history-pay-invoice/billing-history-pay-invoice.vue';
import BillingHistoryInvoiceListItem from './billing-history-invoice-list-item/billing-history-invoice-list-item.vue';

export default {
  name: 'billing-history',
  components: {
    BillingHistoryPayInvoice,
    BillingHistoryInvoiceListItem,
  },
  props: {
    paymentMethod: {
      type: Object,
    },
    stripe: {
      type: Object,
    },
  },
  data() {
    return {
      showPayInvoice: false,
      invoices: [],
      selectedInvoice: '',
    };
  },
  methods: {
    handleClose() {
      this.showPayInvoice = false;
      this.selectedInvoice = '';
    },
    handlePaid() {
      this.showPayInvoice = false;
      this.selectedInvoice = '';
      this.getInvoices();
    },
    handlePayInvoice(invoice) {
      this.selectedInvoice = invoice;
      this.showPayInvoice = true;
    },
    getInvoices() {
      const { uuid } = this.$store.getters['account/getActiveAccount'];
      if (uuid) {
        return API.get(`${ENDPOINTS.GET_STRIPE_INVOICE}/?accountID=${uuid}`)
          .then((response) => {
            if (response.status === 200 && response.data.data.data) {
              this.invoices = response.data.data.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      return false;
    },
  },
  mounted() {
    this.getInvoices();
  },
};
